module.exports = __webpack_public_path__ + "static/img/evaluation-scheme.5d9d5a05.png";